import { TagInfo } from '../TagInfo';

export enum ErrorLevel {
  ERROR,
  WARNING,
  INFO,
  NONE
}

export interface ErrorModel {
  level?:ErrorLevel;
  message?:string;
  subMessage?:string;
}
export enum ComposerPresetType{
  'overlay' = "Overlay",
  'overlay-survey' = "Overlay Survey",
  'channel-install' = "Channel Install",
  'product-carousel' = "Expand",
  'skippable' = "Skippable",
}

const unsupportedError :ErrorModel =  {
  level: ErrorLevel.WARNING,
  message: 'This tag includes components that are not fully supported within this preview page.',
  subMessage: 'For the best user experience, we recommend previewing this project on a Roku device',
};

export const tagNotFoundError :ErrorModel =  {
  level: ErrorLevel.ERROR,
  message: "The require tag is not found",
};

export const checkIfSupportedPreset =(tagInfo:TagInfo)=>{
  const unsupportedPrest = ["Video Extender","Skippable","Channel Install"];
  const preset = tagInfo?.preset || "";
  if(unsupportedPrest.indexOf(preset) > -1){
    return unsupportedError;
  }
  return undefined;
};
